var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbcaa;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#639;}.cls-5{fill:#efa44b;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "perso_2",
    "data-name": "perso 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 490.41,
    cy: 219.5,
    r: 169
  }), /*#__PURE__*/React.createElement("g", {
    id: "frame_2_miroir",
    "data-name": "frame 2 miroir"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1100.41,1233.5s34,67,64,35-23-74-23-74Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M976.41,1089.5s-23-82,55-70l125,172s-23,41-60,50C1048.41,1183.5,976.41,1089.5,976.41,1089.5Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M941.41,1251.5v-203s0-50,66-50,66,40,66,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M941.41,1251.5s-2,103-58,184c-14,0-41,71-41,71l156,69s35-55-19-85c30-46,94-175,94-239Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1173.41,1457.5s-42.5-166.38-100.5-206.5h-132c-10.94,38.17,82.16,144.56,82.16,144.56s47.34,67.94,52.34,109.94c0,0-5,9-2,18s25,52,25,52l157-75S1229.41,1421.5,1173.41,1457.5Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bras_arri\\xE8re",
    "data-name": "bras arri\\xE8re"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M852,1194.56s-53.46,52.8-13.84,71.62,63.47-44.45,63.47-44.45Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M951.33,1032.59s71.1-46.89,83.43,31.06L909,1235.1s-46.06-9.41-65.9-41.91C883.74,1129.8,951.33,1032.59,951.33,1032.59Z",
    transform: "translate(-517 -611)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M973.8,1003.55c8.6-3.4,19.44-5.55,33.11-5.55,66,0,68,40,68,40S1059.91,1013,973.8,1003.55Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 423.91,
    y: 632,
    width: 133,
    height: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M967.91,915l-10,77.13C941.34,1006.48,777.2,964,814.11,775c2.6-13.31,14-39,29-65-46,0-86,218-160,260-60.69-74-70.11-364.45,110-343,21,3,60,34,63.78,67.17,41.89-39.67,105.21-50.55,161-46.17,26.27,2.06,70.79,18.2,101,41a196,196,0,0,1,49,55c17.2,34-21.82,88.28-111.8,61-13.92,34.16-29.91,57-49.2,62,0,0-27.67-26.15-54-14C926.91,865,932.91,919,967.91,915Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightFrame2);
export default __webpack_public_path__ + "static/media/right_frame_2.c3e46e63884e080e9ca16242b194eadb.svg";
export { ForwardRef as ReactComponent };